
import { Component, Prop, Vue, } from 'vue-property-decorator';
import ProgressSteps from '~/components/progress-steps/progress-steps.vue';

const progressStepsLabels = [
	'Your details',
	'Check details',
	'Choose amount',
	'Make payment',
];

@Component({
	components: {
		ProgressSteps,
	},
})
export default class PayBillProgressSteps extends Vue {
	@Prop({
		type: Number,
		required: true,
	})
	currentStep!: number;

	progressStepsLabels = progressStepsLabels;
}
